// extracted by mini-css-extract-plugin
export default {"RecipeSearchModal":"G89dc73","overlay":"Ge2afa6","modalFooterContent":"Gf8bf1b"};